import { equals, first, last } from '@execonline-inc/collections';
import { when } from '@execonline-inc/maybe-adapter';
import { assertNever } from '@kofno/piper';
import { just } from 'maybeasy';
import { fromArrayMaybe } from 'nonempty-list';
import LearningCollectionEditStore from '..';
import { removeLeadingQuestionMark, updateUrl } from '../../../../../../ListFilter';
import { Ready, Visibility } from '../Types';

const getQueryParams = () =>
  fromArrayMaybe(decodeURI(window.location.search).split('&').map(removeLeadingQuestionMark));

const getFirstQueryParam = () =>
  getQueryParams()
    .map((queryParam) => queryParam.first.split('='))
    .getOrElse(() => []);

const getCelebrationValue = (): Visibility =>
  just({})
    .assign('first', first(getFirstQueryParam()))
    .assign('last', last(getFirstQueryParam()))
    .andThen(({ first, last }) => when(equals(first, 'celebrate'), equals(last, 'true')))
    .andThen((celebration) => when<Visibility>(celebration, 'show'))
    .getOrElseValue('hide');

const ready = (store: LearningCollectionEditStore, state: Ready) => {
  switch (state.step) {
    case 'describe':
    case 'build':
      store.editingDetails(getCelebrationValue());
      updateUrl('');
      break;
    case 'customize':
      store.buildingWithCelebrationPage(getCelebrationValue());
      updateUrl('');
      break;
    case 'preview':
      store.previewing(
        state.learningCollectionEditFormResource,
        state.template,
        state.celebrationPage,
      );
      updateUrl('');
      break;
    case 'share':
      store.sharing();
      break;
    default:
      assertNever(state.step);
  }
};

export default ready;
